module.exports = {
          srcSet: __webpack_public_path__ + "public/c84cdc4566e044dec341668f3b222492-80.png"+" 80w",
          images:[ {path: __webpack_public_path__ + "public/c84cdc4566e044dec341668f3b222492-80.png",width: 80,height: 80}],
          src: __webpack_public_path__ + "public/c84cdc4566e044dec341668f3b222492-80.png",
          toString:function(){return __webpack_public_path__ + "public/c84cdc4566e044dec341668f3b222492-80.png"},
          
          width: 80,
          height: 80
        }